export default "__VITE_ASSET__CQG_IugV__"